import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import { FOCUSED_TEXT_COLOR, GRAY_COLOR } from './SimpleInput'
import InputStyles from './InputStyles'

const Input = styled.input`
    ${InputStyles}
`

const RawInput = React.forwardRef(({
    valid,
    placeholder,
    height,
    onChange,
    onFocus,
    onBlur,
    value,
    padding,
    type,
    dataTest,
    theme,
    focused,
    withErrors,
    ...restProps
}, ref) => <Input
    data-test={dataTest}
    focused={focused.toString()}
    valid={valid}
    height={height}
    padding={padding}
    type={type}
    error={withErrors || !valid}
    fontColor={focused ? FOCUSED_TEXT_COLOR : GRAY_COLOR}
    value={value || ''}
    placeholder={placeholder}
    onChange={onChange}
    onFocus={onFocus}
    onBlur={onBlur}
    theme={theme}
    {...restProps}
    ref={ref}
    />)

RawInput.displayName = 'RawInput'
RawInput.propTypes = {
    valid: PropTypes.bool,
    placeholder: PropTypes.node,
    height: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.string,
    padding: PropTypes.string,
    type: PropTypes.string,
    dataTest: PropTypes.string,
    theme: PropTypes.object,
    focused: PropTypes.bool,
    withErrors: PropTypes.bool,
    mask: PropTypes.string,
}

export default RawInput